import React from 'react';
import { sharedConstants } from 'shared-helpers';


// constants
import { CONTACT_FORM_TYPE, HUBSPOT_FORM_SOURCE } from '../../lib/constants';
const TAXONOMIES = sharedConstants.TAXONOMIES;

// components
import ContactForm from './ContactForm';

const ContactSalesPopup = (props) => {

    const hasPage = [
        HUBSPOT_FORM_SOURCE.single_profile_locked_contacts,
        HUBSPOT_FORM_SOURCE.single_profile_locked_sections
    ]

    const title = hasPage.includes(props.page)
        ? 'Discover the power of MAGNiTT'
        : 'Unlock access to Private Capital data'

    return (
        <div className="contact-sales-popup-form">
            <div
                className="modal fade"
                id="contactFormModal"
                data-dismiss="modal"
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="shared-modal-header">
                                <h4>{title}</h4>
                            </div>
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                            >
									&times;
                            </button>
                        </div>

                        <div className="modal-body">
                            <ContactForm
                                page={props.page}
                                popup={true}
                                taxonomyType={
                                    TAXONOMIES.salesContactOptions
                                }
                                formType={CONTACT_FORM_TYPE.enterprise}
                                buttonLabel="Contact Sales"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ContactSalesPopup;
